import React, { useState } from 'react'
import { Box, Button, Grid2, TextField, Typography } from '@mui/material'
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { registerUser } from '../../apis/apiList/authApi';
import { useMessage } from '../../context/MessageContext';
import axios from 'axios';

const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email format").required("Email is required"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    // phone: Yup.string().matches(/^\d+$/, "Phone must be numbers only").required("Phone is required"),
    password: Yup.string().min(3, "Password must be at least 3 characters").required("Password is required"),
    organization: Yup.string().required("Organization is required"),
});

function AddUser({ handleCancel, orgId, organization, handleNewAddedUser }) {
    const { showMessage } = useMessage();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [fetchedUserDetails, setFetchedUserDetails] = useState({});

    const handleSubmit =async (values) => {
        console.log('values', values)
        try {
            let data = {}
            if(fetchedUserDetails?.email == values.email){
                data = {
                    orgId: orgId,
                    profile_pic: values.profile_pic,
                    folderid: organization.boxFolderId,
                    ...values,
                    vpmaProfileName: fetchedUserDetails.profile_image,
                    isVpmaUser: true,
                    userType: fetchedUserDetails.type,
                    userId: fetchedUserDetails._id,
                    role: fetchedUserDetails.role,
                    userName: fetchedUserDetails.username,
                    vpmaUserDetails: fetchedUserDetails,
                }
            } else {
                data = {
                    orgId: orgId,
                    profile_pic: values.profile_pic,
                    folderid: organization.boxFolderId,
                    ...values,
                    isVpmaUser: false,
                }
            }
            console.log('data', data)
            const userData = await registerUser(data, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            console.log('user added', userData)
            handleNewAddedUser(userData.data);
            setIsSubmitted(false)
            showMessage('User added successfully', 'success')
            handleCancel()
        }catch (err) {
            console.log('err ', err)
            showMessage(err?.response?.data?.message || 'Something went wrong', 'error')
        } finally {
            setIsSubmitted(false)
        }
    }

    return (
        <Box>
            <Typography variant='h3' mb={4} mt={2}>Add User</Typography>
            <Box>
                <Formik
                    initialValues={{
                        email: "",
                        firstName: "",
                        lastName: "",
                        phone: "",
                        password: "",
                        organization: organization.organizationName,
                        jobTitle: "",
                        twitter: "",
                        linkedIn: "",
                        profile_pic: null,
                        notes: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        console.log("Form Data:", values);
                        setSubmitting(false);
                        setIsSubmitted(true)
                        handleSubmit(values);
                    }}
                >
                    {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => {
                        let handleEmailBlur = async (e) => {
                            handleBlur(e); // Formik's default behavior
                            const email = e.target.value;
                            if (email) {
                                try {
                                    const response = await axios.post(`${process.env.REACT_APP_VPMA_BACKEND_URL}/snapshotvideos/user/fetch/user`, {
                                        email: email,
                                    });
                                    console.log('response', response);
                                    // const response = await getUserByEmailFromVpma(email);

                                    let userData = {};
                                    if( response.status == 200 && response.data.user.length > 0){
                                        userData = response.data.user[0]
                                    }
                                    console.log('Fetched user data:', userData);
                        
                                    // Populate form fields if user is found
                                    if (userData) {
                                        setFetchedUserDetails(userData);
                                        setFieldValue('firstName', userData.first_name || '');
                                        setFieldValue('lastName', userData.last_name || '');
                                        setFieldValue('password', userData.password || '');
                                        setFieldValue('phone', userData.phone || '');
                                        setFieldValue('jobTitle', userData.job_title || '');
                                        setFieldValue('twitter', userData.twitter || '');
                                        setFieldValue('linkedIn', userData.linkedin || '');
                                        setFieldValue('notes', userData.notes || '');
                                    }
                                } catch (error) {
                                    console.error('Error fetching user:', error);
                        
                                    // Optional: if you want to show a message
                                    // showMessage('No user found, you can create a new one.', 'info');
                        
                                    // No need to clear or change anything, user can manually fill
                                }
                            }
                        };
                        
                        return (<Form>
                            <Grid2 container spacing={2}>

                                {/** First Name **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="First Name"
                                        name="firstName"
                                        variant="outlined"
                                        error={touched.firstName && !!errors.firstName}
                                        helperText={<ErrorMessage name="firstName" />}
                                    />
                                </Grid2>

                                {/** Last Name **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Last Name"
                                        name="lastName"
                                        variant="outlined"
                                        error={touched.lastName && !!errors.lastName}
                                        helperText={<ErrorMessage name="lastName" />}
                                    />
                                </Grid2>

                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Email"
                                        name="email"
                                        variant="outlined"
                                        error={touched.email && !!errors.email}
                                        helperText={<ErrorMessage name="email" />}
                                        onBlur={handleEmailBlur}
                                    />
                                </Grid2>

                                {/** Phone **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Phone"
                                        name="phone"
                                        variant="outlined"
                                        error={touched.phone && !!errors.phone}
                                        helperText={<ErrorMessage name="phone" />}
                                    />
                                </Grid2>

                                {/** Password **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        type="password"
                                        label="Password"
                                        name="password"
                                        variant="outlined"
                                        error={touched.password && !!errors.password}
                                        helperText={<ErrorMessage name="password" />}
                                    />
                                </Grid2>

                                {/** Organization **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Organization"
                                        name="organization"
                                        variant="outlined"
                                        disabled
                                        error={touched.organization && !!errors.organization}
                                        helperText={<ErrorMessage name="organization" />}
                                    />
                                </Grid2>

                                {/** Job Title **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Job Title"
                                        name="jobTitle"
                                        variant="outlined"
                                    />
                                </Grid2>

                                {/** Twitter **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Twitter"
                                        name="twitter"
                                        variant="outlined"
                                    />
                                </Grid2>

                                {/** LinkedIn **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="LinkedIn"
                                        name="linkedIn"
                                        variant="outlined"
                                    />
                                </Grid2>

                                {/** File Upload (Profile Image) **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <label htmlFor="profile_pic">Upload Profile Pic</label>
                                    <input
                                        type="file"
                                        name="profile_pic"
                                        className="form-control"
                                        onChange={(event) => setFieldValue("profile_pic", event.currentTarget.files[0])}
                                    />
                                </Grid2>

                                {/** Notes **/}
                                <Grid2 size={{ xs: 12, md: 6 }}>
                                    <Field
                                        as={TextField}
                                        fullWidth
                                        label="Notes"
                                        name="notes"
                                        variant="outlined"
                                    />
                                </Grid2>
                            </Grid2>
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'start', mt: 4 }}>
                                <Button variant='contained' type="submit" disabled={isSubmitted}>{isSubmitted? 'Adding': 'Add'}</Button>
                                <Button variant='contained' onClick={() => { handleCancel() }}>Cancel</Button>
                            </Box>
                        </Form>)
                    }}
                </Formik>
            </Box>
        </Box>
    )
}

export default AddUser